import { isMobile } from "src/utils/device";
import MyDocumentPage from "./MyDocumentPage";
import MyDocumentPageMobile from "./MyDocumentPageMobile";

const MyDocumentPageIndex = () => {
    return isMobile() ? <MyDocumentPageMobile /> : <MyDocumentPage />;
};

export default MyDocumentPageIndex;